import { render, staticRenderFns } from "./AtmPayment.vue?vue&type=template&id=531d3333&scoped=true&"
import script from "./AtmPayment.vue?vue&type=script&lang=js&"
export * from "./AtmPayment.vue?vue&type=script&lang=js&"
import style0 from "./AtmPayment.vue?vue&type=style&index=0&id=531d3333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d3333",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531d3333')) {
      api.createRecord('531d3333', component.options)
    } else {
      api.reload('531d3333', component.options)
    }
    module.hot.accept("./AtmPayment.vue?vue&type=template&id=531d3333&scoped=true&", function () {
      api.rerender('531d3333', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/AtmPayment.vue"
export default component.exports